// src/api/homePageProductsapi.js
import { getErrorMessage } from "../config/errorConfig";
import { FEATURED_PRODUCTS_URL } from "../config/apiConfig";

// `fetchPromotions` and `fetchRecommendedForYou` (the signed-in landing
// rails) were retired on 2026-10-22: the landing page shows the featured
// grid to everyone.
const FEATURED_URL = FEATURED_PRODUCTS_URL;



/**
 * Featured products — Commerce API GET /featured-products (2026-10-20; was the
 * Cloud Function featured_products, POST { page, per_page }). The Commerce
 * API has no paging: one fixed list, so there is one page. The landing page
 * still passes (page, perPage); both are ignored.
 */
export const fetchFeaturedProducts = async () => {
  const response = await fetch(FEATURED_URL, { method: "GET" });

 if (!response.ok) {
         // Map HTTP status to user-friendly error
         let errorMessage;
         if (response.status >= 500) {
           errorMessage = getErrorMessage("API_SERVER_ERROR");
         } else if (response.status === 404) {
           errorMessage = getErrorMessage("API_NOT_FOUND");
         } else if (response.status === 429) {
           errorMessage = getErrorMessage("API_RATE_LIMITED");
         } else {
           errorMessage = getErrorMessage("API_BAD_REQUEST");
         }
   
         throw new Error(errorMessage);
       }
  const data = await response.json();
  return {
    records: Array.isArray(data.featured_products) ? data.featured_products : [],
    pages: 1,
  };
};

